module.exports = __webpack_public_path__ + "static/media/matnrrd_3-719w.3370cade.png";